import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Plus } from 'lucide-react'
import { fetchAuditors } from '@frontend/lib/api'
import { usePermissions } from '@frontend/hooks/usePermissions'
import { AppLayout } from '@frontend/components/layout/AppLayout'
import { Button } from '@frontend/components/ui/button'
import { Card, CardContent } from '@frontend/components/ui/card'
import { Spinner } from '@frontend/components/ui/spinner'
import { AuditorsTable, AuditorModal } from '@frontend/components/auditors'

export function Auditors() {
  const [addOpen, setAddOpen] = useState(false)
  const { can } = usePermissions()

  const { data, isLoading, error } = useQuery({
    queryKey: ['auditors'],
    queryFn: fetchAuditors,
  })

  const auditors = data?.auditors ?? []

  return (
    <AppLayout>
      <div className="space-y-6">
        {/* Page header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">Auditors</h1>
            <p className="mt-1 text-muted-foreground">Manage auditing firms and Riveron&apos;s qualified opinions</p>
          </div>
          {can('auditors.create') && (
            <Button onClick={() => setAddOpen(true)}>
              <Plus className="h-4 w-4 mr-1" />
              Add Auditor
            </Button>
          )}
        </div>

        {/* Main content card */}
        <Card className="shadow-sm">
          <CardContent className="p-0">
            {isLoading ? (
              <div className="flex justify-center py-16">
                <Spinner size="lg" />
              </div>
            ) : error ? (
              <div className="py-16 text-center">
                <p className="text-destructive">Failed to load auditors.</p>
                <p className="mt-1 text-sm text-muted-foreground">Please try refreshing the page.</p>
              </div>
            ) : (
              <div className="p-4">
                <AuditorsTable auditors={auditors} />
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      {/* Add Auditor Modal */}
      <AuditorModal mode="create" open={addOpen} onOpenChange={setAddOpen} />
    </AppLayout>
  )
}
